import React, {useState} from 'react';
import styled from "styled-components";
import Image from "@/components/common/Image";
import {getCssSizeValue, getFontSize, getHtmlFromRedactorField, removeTags} from "@/utils/utils";
import {BlockImageWrapper, ImageBlend, ImageTextContainer} from "@/components/payment/RightBlocks/ImageTextLinkBlock";
import Transfers from "@/components/footer/Transfers";
import useGlobals from "@/hooks/useGlobals";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {TOOLTIP_POSITION} from "@/components/ToolTip/BaseToolTip";
import CopyToolTip from "@/components/ToolTip/Variants/CopyToolTip";

const Wrapper = styled.div`
	width: 100%;
	cursor: pointer;
`

const AccountsList = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: ${({theme}) => theme.colors.richBlack};
	color: ${({theme}) => theme.colors.white};
	z-index: 4;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	//align-items: flex-end;
	align-items: flex-start;
	padding-left: ${getCssSizeValue(72, BREAKPOINTS.DESKTOP)};
	//padding-top: ${getCssSizeValue(122, BREAKPOINTS.DESKTOP)};
	padding-top: ${getCssSizeValue(110, BREAKPOINTS.DESKTOP)};
	padding-right: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	//padding: 24px 16px;
	overflow-y: auto;
	text-align: left;
	@media(min-width: 2560px) {
		padding-top: ${getCssSizeValue(122, BREAKPOINTS.DESKTOP)};
	}
	* {
		//font-size: 15px;
		.typo-strawford-50 {
			font-size: 15px;
		}
		.category-title {
			font-size: ${getFontSize(16, BREAKPOINTS.MOBILE)};
			line-height:${getFontSize(19.2, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.bold};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
				line-height: ${getFontSize(32, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(21.6, BREAKPOINTS.DESKTOP)};
			}
		}
	}
	&::-webkit-scrollbar {
		display: none;
	}
`

const AccountDetails = styled.div`
	width: ${getCssSizeValue(299, BREAKPOINTS.DESKTOP)};
	min-height: ${getCssSizeValue(203, BREAKPOINTS.DESKTOP)};
	background-color: ${({theme}) => theme.colors.white};
	padding: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	color: ${({theme}) => theme.colors.richBlack};
	p.transfer-data-title {
		color: ${({theme}) => theme.colors.richBlack};
		margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		font-weight: ${({theme}) => theme.fontWeight.bold};
	}
	div.transfer-data-info {
		font-weight: ${({theme}) => theme.fontWeight.medium};
	}
`

const CloseButton = styled.div`
	position: absolute;
	z-index: 5;
	top: 0;
	right: 0;
	width: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	height: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	transition: opacity 0.3s ease-in-out;
	opacity: 0;
	background-color: ${({theme}) => theme.colors.chilliRed};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
		height: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
		svg {
			//width: 70%;
			width: ${getCssSizeValue(30, BREAKPOINTS.DESKTOP)};
			height: ${getCssSizeValue(30, BREAKPOINTS.DESKTOP)};
		}
	}
	&.visible {
		transition: opacity 0.3s ease-in-out;
		opacity: 1;
	}
`

const ImageTextAccountBlock = ({className, data}) => {
	const blendOpacity = data?.blendOpacity || 50;
	const imageUrl = data?.image?.url || '';
	const text = data?.text || ''
	const [isAccountsListVisible, setIsAccountsListVisible] = useState(false);
	const { footer, paymentsTransferData } = useGlobals();
	const title = footer?.transfers?.title || '';
	const copiedText = footer?.transfers?.itemCopiedText || '';
	const transfersCategories = footer?.transfers?.transferCategories || [];
	const instructionsText = paymentsTransferData?.instructionsText || '';
	const transferInfo = paymentsTransferData?.transferInfo || '';
	const transferInfoDescription = paymentsTransferData?.transferInfoDescription || '';
	const handleClose = (e) => {
		e.stopPropagation();
		setIsAccountsListVisible(false)
	}
	return (
		<Wrapper
			onClick={
			// () => setIsAccountsListVisible(!isAccountsListVisible)
				() => setIsAccountsListVisible(true)
			}
			className={className}>
			<BlockImageWrapper>
				<CloseButton className={isAccountsListVisible ? 'visible' : ''} onClick={(e) => handleClose(e)}>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
						<path
							d="M19.0043 4.58534C18.5707 4.15174 17.8703 4.15174 17.4367 4.58534L12 10.0109L6.56336 4.57422C6.12976 4.14062 5.42933 4.14062 4.99573 4.57422C4.56213 5.00782 4.56213 5.70825 4.99573 6.14185L10.4324 11.5785L4.99573 17.0152C4.56213 17.4488 4.56213 18.1492 4.99573 18.5828C5.42933 19.0164 6.12976 19.0164 6.56336 18.5828L12 13.1461L17.4367 18.5828C17.8703 19.0164 18.5707 19.0164 19.0043 18.5828C19.4379 18.1492 19.4379 17.4488 19.0043 17.0152L13.5676 11.5785L19.0043 6.14185C19.4268 5.71937 19.4268 5.00782 19.0043 4.58534Z"
							fill="#EBEBEB"/>
					</svg>
				</CloseButton>
				<ImageBlend
					$opacity={blendOpacity}
				/>
				{isAccountsListVisible && (
					<AccountsList>
						<Transfers isPaymentBlockVariant={true}/>
						<AccountDetails>
							<p className='transfer-data-title typo-strawford typo-strawford-29'>{transferInfo}</p>
							<CopyToolTip
								copyValue={removeTags(transferInfoDescription, ['p', 'br'])}
								position={TOOLTIP_POSITION.TOP_END}
							>
								<div className='typo-strawford typo-strawford-45 transfer-data-info' dangerouslySetInnerHTML={getHtmlFromRedactorField(transferInfoDescription)}/>
							</CopyToolTip>
						</AccountDetails>
					</AccountsList>
				)}
				<Image
					src={imageUrl}
					fit="cover"
					alt={'image'}
				/>
				<ImageTextContainer>
					<div className="typo-borna typo-borna-77" dangerouslySetInnerHTML={getHtmlFromRedactorField(text)}/>
				</ImageTextContainer>
			</BlockImageWrapper>
		</Wrapper>
	);
};

export default ImageTextAccountBlock;
